/**
 * Копирование в буфер обмена. Clipboard API есть только в защищённом контексте и может быть
 * запрещён браузером — тогда false, и экран оставляет ссылку для ручного копирования.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (!navigator.clipboard) return false
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
